class NSSRecommendations extends HTMLElement {
  constructor() {
    super();

    this.debug = false;
    this.formatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
    this.swiper;
  }

  connectedCallback() {
    if (this.debug) console.log("[NSS][Recommendations] Connected.");
    this.initRecommendations();
  }

  initCarousel() {
    const carouselEl = this.querySelector(`.swiper`);

    this.swiper = new Swiper(carouselEl, {
      autoHeight: false,
      grabCursor: true,
      slidesPerView: "auto",
      spaceBetween: 15,
      centeredSlides: true,
      // loop: true,

      a11y: {
        enabled: true,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },

      navigation: {
        prevEl: ".nss-recommendations-prev",
        nextEl: ".nss-recommendations-next",
      },
    });
  }

  initRecommendations() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      const url = this.dataset.url;
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("nss-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            if (recommendations.querySelectorAll(".swiper-slide").length < 1) {
              this.style.display = "none";
            }
            this.initCarousel();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 0px 0px",
    });
    observer.observe(this);
  }
}

let elementName = `nss-recommendations`;
if (typeof customElements.get(elementName) === `undefined`) {
  customElements.define(elementName, NSSRecommendations);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
